import React from 'react'

const Why = () => {
  return (
    <div className='w-full mb-36'>
        <h2 className='text-center font-medium text-4xl'>Why Choose Samdenkens?</h2>
       <section className='flex gap-9 w-[90%] mt-10 mx-auto sm:flex-col'>
       <div>
            <h2 className='text-center font-medium text-lg'>Unmatched Expertise</h2>
            <p className='mt-2 text-center font-light'>Our deep industry knowledge and dedication to continuous improvement allow us to offer unparalleled expertise to our clients and partners.</p>
        </div>
        <div>
            <h2 className='text-center font-medium text-lg'>Proven Success</h2>
            <p className='mt-2 text-center font-light'>Our history of successful projects and high client satisfaction underscores our ability to deliver exceptional results.</p>
        </div>
        <div>
            <h2 className='text-center font-medium text-lg'>Innovation-Driven</h2>
            <p className='mt-2 text-center font-light'>We are constantly pushing the boundaries of what’s possible in the energy sector, staying ahead of the curve with advanced, forward-thinking solutions.</p>
        </div>
        <div>
            <h2 className='text-center font-medium text-lg'>Integrity at the Core</h2>
            <p className='mt-2 text-center font-light'>Our commitment to ethical business practices and transparency builds trust with our clients, partners, and employees, ensuring long-term relationships founded on integrity.</p>
        </div>
       </section>
    </div>
  )
}

export default Why